
import {
  GeneratorElutionDto,
  CreateGeneratorElutionDto,
  CreateQcTestResultDto,
  QualityControlData,
  QcTestResultDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { axios, PaginatedQueryBase } from './api'

export type GeneratorElutionsFilters = PaginatedQueryBase

const endpoint = 'generator-elution'
const baseUrl = process.env.REACT_APP_RADIOPHARMACY_API_URL

class GeneratorElutionService extends BaseCrudService<
  GeneratorElutionDto,
  CreateGeneratorElutionDto,
  {},
  GeneratorElutionsFilters
> {
  constructor() {
    super(endpoint, baseUrl)
  }

  getQualityControls(id: string): Promise<QualityControlData | null> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('get', `${this.endpoint}/${id}/quality-controls`)
      axios(configs, resolve, reject)
    })
  }

  completeQualityControl(id: string, completedByMemberId: number): Promise<void> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('patch', `${this.endpoint}/${id}/quality-control/complete`, { completedByMemberId })
      axios(configs, resolve, reject)
    })
  }

  recordQcTestResult(id: string, dto: CreateQcTestResultDto, file?: File): Promise<QcTestResultDto> {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('payload', JSON.stringify({ ...dto, entityType: 'generatorElution', entityId: id }))
      if (file) {
        formData.append('file', file)
      }
      const configs = this.buildConfig('post', 'qc-test-result', formData)
      axios(configs, resolve, reject)
    })
  }

  subscribeToEvents(onElutionCreated: (elution: GeneratorElutionDto) => void): () => void {
    const eventSource = new EventSource(`${baseUrl}/${endpoint}/events`)
    eventSource.addEventListener('elution.created', (messageEvent) => {
      const elution: GeneratorElutionDto = JSON.parse((messageEvent as MessageEvent).data)
      onElutionCreated(elution)
    })
    eventSource.onerror = () => console.error(`SSE ${endpoint} connection error`)
    return () => eventSource.close()
  }

  getCurrentActivities(ids: string[]): Promise<Record<string, number | null>> {
    return new Promise((resolve, reject) => {
      const configs = this.buildConfig('get', `${this.endpoint}/current-activity`, undefined, { ids: ids.join(',') })
      axios(configs, resolve, reject)
    })
  }
}

export const generatorElutionService = new GeneratorElutionService()
